'use client'

import { useState } from 'react'

import { Button } from '@src/components/Button/Button'
import { Dropdown } from '@src/components/Dropdown/Dropdown'
import { GeoRedirectionModalContent } from '@src/components/GeoRedirectionModal/GeoRedirectionModalContent'
import { dropdownOptions } from '@src/components/GeoRedirectionModal/dropdownOptions'
import { useGeoRedirectionModalHandlers } from '@src/components/GeoRedirectionModal/useGeoRedirectionModalHandlers'
import { useLocale } from '@src/i18n/LocaleProvider'
import type { CountryCode } from '@src/i18n/locales'

export const GeoRedirectionModal = ({
  userCountryCode,
}: {
  userCountryCode: string | undefined
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const [selectedCountryCode, setSelectedCountryCode] = useState<string | undefined>(() => {
    if (dropdownOptions.includes(userCountryCode as CountryCode)) return userCountryCode
    return undefined
  })
  const { t } = useLocale('geo-redirection-modal')
  const { t: tc } = useLocale('countries')

  const items = dropdownOptions.map((code) => ({
    id: code,
    displayName: tc(code),
    name: tc(code),
  }))

  const { onConfirm, onCancel, isLoading } = useGeoRedirectionModalHandlers({
    selectedCountryCode,
    onClose: () => setIsOpen(false),
  })

  return (
    <GeoRedirectionModalContent isOpen={isOpen} onClose={onCancel} title={t('title')}>
      <p className="mb-12 text-body-base lg:mb-8">{t('subtitle')}</p>

      <Dropdown
        listboxOptionsClassNames="z-1000"
        placeholder={t('select-your-country')}
        items={items}
        selectedId={selectedCountryCode}
        onItemIdSelected={(id) => {
          setSelectedCountryCode(id)
        }}
      />

      <div className="mt-6 flex flex-col gap-2 lg:mt-8 lg:flex-row">
        <Button isLoading={isLoading} onClick={onConfirm} size="large">
          {t('confirm')}
        </Button>
        <Button onClick={onCancel} size="large" variant="secondary">
          {t('cancel')}
        </Button>
      </div>
    </GeoRedirectionModalContent>
  )
}
